const _ = require('underscore');
const $ = require('jquery');
const SubtitleScope = require('../scopes/subtitle');
import { consts} from './consts';

module.exports = {
	$track: null,
	subtitle: [],
	frameRate: null,
	maxCharactersInLine: null,
	readData: function (model) {
		var deferrer = $.Deferred();

		this.movieModel = model;

		_.bindAll(this, 'parseResponse', 'parseSubtitle', 'clearStorage');
		
		this.clearStorage();
 
		this.loadSubtitle(deferrer);

		return deferrer.promise();
	},
	getUrlParameterByName: function (name) {
		var match = RegExp('[?&]' + name.toLowerCase() + '=([^&]*)').exec(window.location.search.toLowerCase());
		return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
	},
	loadSubtitle: async function (deferrer) {
		var url;

		//'https://www.capnsub.com/v1/controllers';
		//"http://localhost:11956/controllers"; 
		//https://test.capnsub.com/controllers
		//https://direct.capnsub.com/controllers

		var data = {
			movieId: this.getUrlParameterByName("MovieId"),
		};

		if (this.movieModel.has('currentLanguageId')) {
			url = consts.BASE_END_POINT + '/player/GetMovieDataByTranslationId';
			data['translationId'] = this.movieModel.get('currentLanguageId');
		} else {
			url = consts.BASE_END_POINT + '/player/GetMovieData';
			localStorage.removeItem('capNsub-language');
		}
		if (this.getUrlParameterByName("TranslationId")) {
			data['translationId'] = this.getUrlParameterByName("TranslationId");
			localStorage.setItem('capNsub-language', data['translationId']);
			url = consts.BASE_END_POINT + '/player/GetMovieDataByTranslationId';
		} else if (localStorage.hasOwnProperty('capNsub-language')) {
			data['translationId'] = localStorage.getItem('capNsub-language');
			localStorage.setItem('capNsub-language', data['translationId']);
			url = consts.BASE_END_POINT + '/player/GetMovieDataByTranslationId';
		}

		var configRequest = {
			url: url,
			type: 'GET',
			data: data,
			dataType: 'json',
			success: (response) => {
				this.parseResponse(response, deferrer);
			}
		};
		//The player can be compiled for linnet, in this case linnet will expose function on the window 
		if (ENVIRONMENT == "LINNET" && window.getAccessToken) {
			configRequest.headers = {
				'Authorization': await window.getAccessToken()
			}
		}

		$.ajax(configRequest);
	},
	parseResponse: function (response, deferrer) {
		this.parseMovieData(response);
		this.parseSubtitle(response, deferrer);
	},
	parseMovieData: function (sub) {
		this.movieModel.set({
			title: sub.videoTitle,
			videoSrc: sub.moviePath,
			frameRate: sub.frameRate,
			currentLanguageId: sub.translationId,
			translationId: sub.translationId,
			availableLanguages: sub.availableLanguages,
			captionLastUpdate: sub.captionLastUpdate,
			position: 0,
			movieId: this.getUrlParameterByName("MovieId")
		});

		this.frameRate = sub.frameRate;
		this.maxCharactersInLine = sub.maxCharactersInLine;
	},
	parseSubtitle: function (response, deferrer) {
		var subtitleModels = [];

		if (response.subtitles != undefined) {
			for (var i = 0; i < response.subtitles.length; i++) {
				var subData = {};
				var current = response.subtitles[i];

				var id = current['id'];
				var hasBox = current['hasBox'];
				var translationId = current['translationId'];
				var status = current['editType'];

				var row1Original = current['firstLine'] == undefined ? "" : current['firstLine'];
				var row2Original = current['secondLine'] == undefined ? "" : current['secondLine'];

				var frameStartOriginal = this.msToFrames(current['startTimeMilisec']);
				var frameEndOriginal = this.msToFrames(current['endTimeMilisec']);
				var isItalicOriginal = current['isItalic'] == undefined ? false : current['isItalic'];

				var row1Edited = current['firstLineEdit'] == undefined ? "" : current['firstLineEdit'];
				var row2Edited = current['secondLineEdit'] == undefined ? "" : current['secondLineEdit'];
				var frameStartEdited = this.msToFrames(current['startTimeMilisecEdit']);
				var frameEndEdited = this.msToFrames(current['endTimeMilisecEdit']);
				var isItalicEdited = (current['isItalicEdit'] == undefined && isItalicOriginal) ? true : current['isItalicEdit'] ? true : false;

				var maxCharactersInLine = response['maxCharactersInLine'];

				var subDataOriginal = {
					id: id,
					row1: row1Original,
					row2: row2Original,
					frameStart: frameStartOriginal,
					frameEnd: frameEndOriginal,
					italic: isItalicOriginal,
					hasBox: hasBox,
					translationId: translationId,
					status: status,
					maxCharactersInLine: maxCharactersInLine
				};
				subData['original'] = subDataOriginal;

				var subDataEdited = {
					id: id,
					row1: row1Edited,
					row2: row2Edited,
					frameStart: frameStartEdited,
					frameEnd: frameEndEdited,
					italic: isItalicEdited,
					hasBox: hasBox,
					translationId: translationId,
					status: status,
					maxCharactersInLine: maxCharactersInLine
				};

				//Old code - Today we force to edit the row1 or row2 in order to consider the subtitle in edit mode			
				// if (
				// 	(!((row1Edited === "") && (row2Edited === ""))) ||
				// 	frameStartEdited != frameStartOriginal ||
				// 	frameEndEdited != frameEndOriginal ||
				// 	isItalicEdited != isItalicOriginal) {
				// 	subData['edited'] = subDataEdited;
				// }

				var isTextEdited = !(row1Edited === "" && row2Edited === "");
				if (isTextEdited) {
					subData['edited'] = subDataEdited;
				}

				subtitleModels.push(subData);
			}
		}

		var subtitleCollection = this.movieModel.get('subtitle');
		if (subtitleCollection.length) {
			subtitleCollection.reset();
		}

		_.each(subtitleModels, function (sub) {
			var mdl = new SubtitleScope.Model();

			mdl.setData(sub.original, sub.original.status);

			if (sub.edited)
				mdl.addToStack(sub.edited);

			mdl.set('frameRate', response.frameRate);

			subtitleCollection.add(mdl);
		});

		deferrer.resolve();

	},
	msToFrames: function (ms) {
		return Math.round((ms) / (1 / this.frameRate * 1000));
	},
	framesToMs: function (frames) {
		return Math.round(frames * (1 / this.frameRate * 1000));
	},
	framesToTime: function(frames) {
		return this.framesToMs(frames) / 1000;
	},
	framesToHMS:function (frames) {
		return this.toHMS(this.framesToMs(frames));
	},
	convertToFrames: function (time, frameFormat) {
		var ms, timestamp, frame;

		if (time.indexOf('.') !== -1) {
			var splittedTime = time.split('.');
			ms = splittedTime[1];
			timestamp = splittedTime[0].split(':');
		} else {
			ms = 0;
			timestamp = time.split(':');
		}

		var hour = parseInt(timestamp[0]);
		var minutes = parseInt(timestamp[1]);
		var seconds = parseInt(timestamp[2]);

		if (frameFormat) {
			frame = ((hour * 60 + minutes) * 60 + seconds) * this.frameRate + parseInt(ms);
		} else {
			frame = ((hour * 60 + minutes) * 60 + seconds + ms / 1000) * this.frameRate;
		}

		if (_.isNaN(hour) || _.isNaN(minutes) || _.isNaN(seconds) || _.isNaN(frame)) return false;

		return Math.ceil(frame);
	},
	convertToTime: function (frame) {
		frame = Math.ceil(frame);
		var msFrames = frame % this.frameRate;
		var time = (frame - msFrames) / this.frameRate;

		var hours = ("0" + Math.floor(time / 3600)).slice(-2);
		var minutes = ("0" + Math.floor((time - hours * 3600) / 60)).slice(-2);
		var seconds = ("0" + Math.floor(time - hours * 3600 - minutes * 60)).slice(-2);
		var subtitleFrame = ("00" + (frame % this.frameRate)).slice(-2);


		return hours + ":" + minutes + ":" + seconds + "." + subtitleFrame;
	},

	convertMinToTime: function (frame) {
		frame = Math.ceil(frame);
		var msFrames = frame % this.frameRate;
		var time = (frame - msFrames) / this.frameRate;

		var hours = ("0" + Math.floor(time / 3600)).slice(-2);
		var minutes = ("0" + Math.floor((time - hours * 3600) / 60)).slice(-2);
		var seconds = ("0" + Math.floor(time - hours * 3600 - minutes * 60)).slice(-2);
		var subtitleFrame = ("00" + (frame % this.frameRate)).slice(-2);


		return seconds + "." + subtitleFrame;
	},

	toHMS: function (time) {
		var insureFrameDevisionFactor = 0.0001;
		var time = Math.floor(time * this.frameRate + insureFrameDevisionFactor) / this.frameRate; //Tal humy : Added
		var normalizedTime = Math.floor(time);

		var hour = this.zeroPad(Math.floor(normalizedTime / 3600), 2);
		var minute = this.zeroPad(Math.floor((normalizedTime % 3600) / 60), 2);
		var second = this.zeroPad((normalizedTime % 3600) % 60, 2);
		var ms = (time - normalizedTime);

		var frame = this.zeroPad(Math.round(Math.round(ms * 1000) / 1000 * this.frameRate), 2);

		return hour + ":" + minute + ":" + second + "." + frame;
	},
	zeroPad: function (num, places) {
		var zero = places - num.toString().length + 1;
		return Array(+(zero > 0 && zero)).join("0") + num;
	},
	clearStorage: function() {
		['capNsub-langauge', 'selected-subtitle', 'capNsub-settings', 'capNusb-player-progress']
			.forEach(keyToRemove => {
				localStorage.removeItem(keyToRemove);
			})
	}
};


// WEBPACK FOOTER //
// ./app/helpers/reader.js